module.exports = __webpack_public_path__ + "img/img5.9dbdc1e4.svg";